<template>
  <div class="programacao-semanal" :class="{ loading: loading }">
    <div class="tabs">
      <div
        class="tab"
        v-for="_tab in tabs"
        :key="_tab.key"
        @click="tab = _tab.key"
        :class="{ active: tab == _tab.key }"
      >
        {{ _tab.name }}
      </div>
    </div>
    <div class="tab-content">
      <table v-if="week">
        <thead>
          <tr>
            <th width="20%">Data | Período</th>
            <th width="50%">Ação | Evento</th>
            <th width="30%">Local | Canal de Realização</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(evento, k) in eventos" :key="k">
            <td data-title="Data | Período">
              {{ evento.data_periodo }}
            </td>
            <td data-title="Ação | Evento">
              {{ evento.nome_do_evento }}
            </td>
            <td data-title="Local | Canal de Realização">
              {{ evento.local__canal_de_realizacao }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="historico">
      <span>Histórico das programações publicadas:</span>
      <nav v-if="week">
        <template v-for="(post, k) in posts">
          <a :key="post.id" :href="`?week=${k}`" @click.prevent="week = post">
            <span
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                height="1em"
                viewBox="0 0 384 512"
              >
                <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                <path
                  d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                /></svg
            ></span>
            {{ post.title.rendered }}
          </a>
        </template>
      </nav>
    </div>
  </div>
</template>

<script>
import PostsService from "@/services/PostsService";
export default {
  props: {
    settings: {},
  },
  data() {
    return {
      tabs: [
        { key: "regiao_central", name: "Central" },
        { key: "regiao_leste", name: "Leste" },
        { key: "regiao_oeste", name: "Oeste" },
      ],
      posts: [],
      tab: "regiao_central",
      week: false,
      loading: false,
      lastpage: 3,
      page: 0,
    };
  },
  mounted() {
    this.getWeek();
  },

  watch: {
    page() {
      this.getWeek();
    },
  },

  computed: {
    title() {
      return `ACONTECE NO SESC ${new Date().getFullYear()}`;
    },
    eventos() {
      if (!this.week) return [];
      return this.week.acf[this.tab].eventos;
    },
  },

  methods: {
    getWeek() {
      this.loading = true;
      PostsService.get(this.page)
        .then((res) => {
          this.posts = res.data;
          this.week = res.data[0];
          this.loading = false;
          this.lastpage = parseInt(res.headers["x-wp-total"]);
        })
        .catch((err) => console.log);
    },
  },
};
</script>

<style lang="scss" scoped>
.programacao-semanal {
  @apply p-4 relative;
  .historico {
    margin: 30px 0 0 0;
    font-size: 16px;
    color: #54595f;
    span {
      text-align: center;
      display: block;
      margin-bottom: 15px;
    }
  }
  &.loading {
    &::before {
      content: " ";
      @apply block absolute top-0 left-0 w-full h-full bg-white opacity-70;
    }
  }
  .tabs {
    @apply flex justify-start items-center;
    .tab {
      @apply py-3 px-6 bg-white text-[#004C99] cursor-pointer text-[16px] uppercase font-bold mb-[-1px] w-[100%];
      &.active {
        @apply bg-white;
        border-top: 1px solid #f6be00;
        border-right: 1px solid #f6be00;
        border-left: 1px solid #f6be00;
        border-bottom: 1px solid #fff;
      }
    }
  }
  .tab-content {
    border: 1px solid #f6be00;
    padding: 20px;
  }
  table {
    font-size: 16px;
    width: 100%;
    text-align: left;
    border-collapse: collapse;
    color: #7a7a7a;
    font-family: sans-serif;
    border: none;
    td {
      border-top: none;
      border-right: none;
      border-bottom: 1px solid #3333;
      border-left: none;
      padding: 10px 15px;
    }
    th {
      border-top: none;
      border-right: none;
      border-bottom: 1px solid #3333;
      border-left: none;
      padding: 5px 15px;
    }
    @media all and (max-width: 800px) {
      @apply border-none;
      thead {
        display: none;
      }
      tr {
        @apply block text-left my-2 border text-[#004C99] bg-gray-300 py-1;
        &:last-child {
          td {
            border-bottom: none !important;
          }
        }
        td {
          @apply block text-left border-none py-1 text-[1em] text-black;
          &::before {
            content: attr(data-title);
            @apply text-[#004C99] font-bold block uppercase text-[0.8em];
          }
        }
      }
    }
  }
  nav {
    @apply flex justify-start items-center my-4;
    a {
      width: 33%;
      display: flex;
      align-items: center;
      span {
        margin: 0 10px 0 0 !important;
        svg {
          fill: #004c99;
        }
      }
    }
    svg {
      fill: #fff;
    }
    .next {
      svg {
        margin-left: 15px;
      }
    }
    .prev {
      svg {
        margin-right: 15px;
      }
    }
  }
  button {
    border: none;
    cursor: pointer;
  }
}
</style>